import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatListModule } from "@angular/material/list";
import { SettingsService } from "src/swagger/api.client.generated";
import { DialogNotificationsComponent } from "./dialog-notifications.component";
import { SharedModules } from "src/app/shared.modules";
import { DialogNotificationService } from "./dialog-notifications.service";
import { BaseModalComponent } from "../base-modal/base-modal.component";
import { PillButtonComponent } from "../pill-button/pill-button.component";
import { NotificationCardComponent } from "../notification-card/notification-card.component";
@NgModule({
  declarations: [DialogNotificationsComponent],
  imports: [
    CommonModule,
    MatListModule,
    SharedModules,
    BaseModalComponent,
    PillButtonComponent,
    NotificationCardComponent,
  ],
  providers: [SettingsService, DialogNotificationService],
})
export class DialogNotificationsModule {}
